var FooterComponent = /** @class */ (function () {
    function FooterComponent() {
        //Variables
        this.currentDate = new Date();
    }
    return FooterComponent;
}());
export { FooterComponent };
